var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cd-activity-volume-chart"},[_c('e-charts',{staticClass:"w-full h-full",attrs:{"autoresize":true,"options":_vm.options}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }